// Create-vs-edit / save-routing / title-prefix derivations extracted from
// components/defaultLayout/EntityDialog&Forms/EntityDialog.vue (the
// editingExistingData computed, the saveEntityData router predicate, and the
// entityNameTitlePrefixOverride computed). Pulled into a pure, framework-agnostic
// module so these mode decisions are unit-tested and survive the Nuxt 2 -> Nuxt 3
// / Vuex -> Pinia migration; the component now forwards to these. Component state
// read off `this` (entityData, desiredAction, isSubentityDialog, the store
// override) is passed in explicitly. Inline console.debug noise is dropped.

import type { IEntityDataItem } from '~/types/models'

// True when the dialog is editing a pre-existing instance (not a delete flow).
export function isEditingExistingData(opts: {
  entityData: IEntityDataItem | undefined
  desiredAction: string | undefined
}): boolean {
  return !!opts.entityData && opts.desiredAction !== 'DELETE'
}

// Whether a save should PATCH (update an existing instance) rather than POST
// (create). A subentity dialog is always creating, so it never patches.
export function shouldPatchOnSave(opts: {
  entityData: IEntityDataItem | undefined
  isSubentityDialog: boolean
}): boolean {
  return !!opts.entityData && !opts.isSubentityDialog
}

// The dialog title prefix. An explicit store override wins (including the empty
// string, used to suppress the prefix). Otherwise it's 'Edit' when editing an
// existing instance in a top-level dialog, else null (create). A subentity
// dialog is always creating a new instance, so it never gets the 'Edit' prefix.
export function resolveTitlePrefix(opts: {
  override: string | undefined
  entityData: IEntityDataItem | undefined
  isSubentityDialog: boolean
}): string | null | undefined {
  const { override, entityData, isSubentityDialog } = opts
  return override || override === ''
    ? override
    : entityData && !isSubentityDialog
    ? 'Edit'
    : null
}
